import React, { useEffect, useState, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { StageBadge } from "@/components/crm/Badges";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pipeline() {
  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const scrollRef = useRef(null);

  const load = useCallback(() => {
    api.get("/leads/pipeline").then((r) => setColumns(r.data.stages)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const scroll = (dir) => {
    scrollRef.current?.scrollBy({ left: dir * 300, behavior: "smooth" });
  };

  return (
    <div className="relative">
      {createPortal(
        <>
          <button onClick={() => scroll(-1)} style={{ position: "fixed", left: 284, top: "50vh", transform: "translateY(-50%)", zIndex: 9999 }} className="rounded-full bg-white border border-navy/20 p-2 shadow-md hover:bg-cream transition-colors">
            <ChevronLeft className="h-5 w-5 text-navy" />
          </button>
          <button onClick={() => scroll(1)} style={{ position: "fixed", right: 24, top: "50vh", transform: "translateY(-50%)", zIndex: 9999 }} className="rounded-full bg-white border border-navy/20 p-2 shadow-md hover:bg-cream transition-colors">
            <ChevronRight className="h-5 w-5 text-navy" />
          </button>
        </>,
        document.body
      )}
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto pb-4 px-10 scrollbar-hide">
        {columns.map(({ value: status, label, count, items }) => (
          <div
            key={status}
            className="flex w-72 flex-shrink-0 flex-col rounded-xl bg-white/70 p-3"
            data-testid={`pipeline-col-${status}`}
          >
            <div className="mb-3 flex items-center justify-between px-1">
              <h3 className="font-display text-sm font-semibold text-navy">{label}</h3>
              <span className="rounded-full bg-navy/10 px-2 py-0.5 text-xs font-bold text-navy">{count}</span>
            </div>
            <div className="flex flex-1 flex-col gap-2.5 overflow-y-auto">
              {items.map((l) => (
                <div
                  key={l.id}
                  onClick={() => navigate(`/leads/${l.id}`)}
                  className="cursor-pointer rounded-lg border border-navy/10 bg-white p-3 shadow-sm transition-all hover:border-gold hover:shadow-md"
                  data-testid={`pipeline-card-${l.id}`}
                >
                  <p className="text-sm font-semibold text-ink">{l.name}</p>
                  <p className="mt-0.5 text-xs text-muted-foreground">{l.interested_service || l.source}</p>
                  <div className="mt-2 flex items-center justify-between">
                    <StageBadge stage={l.stage} />
                    <span className="text-xs text-muted-foreground">{l.city}</span>
                  </div>
                </div>
              ))}
              {items.length === 0 && <p className="px-1 py-4 text-center text-xs text-muted-foreground">No leads</p>}
              {count > items.length && (
                <p className="px-1 py-2 text-center text-xs text-muted-foreground">
                  Showing {items.length} of {count} — use Leads list to view all
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
